<template>
  <div>
    <v-btn color="red" outlined small @click="abrirDialog">
      <v-progress-linear
        v-if="qtde_produtos_silenciados === null"
        indeterminate
        color="white"
        style="width: 162px"
      />

      <template v-else>
        {{ qtde_produtos_silenciados }} ite{{qtde_produtos_silenciados === 1 ? 'm' : 'ns'}} silenciados
        <v-icon size="15" class="ml-1">mdi-bell-off</v-icon>
      </template>
    </v-btn>

    <SysDialogFullscreen v-model="dialog_ativo" titulo="Produtos com Notificação Silenciada">
      <sys-data-table
        v-model="produtos_selecionados"
        :headers="cabecalhos"
        :items="produtos"
        :search="pesquisa"
        :fixed-header="true"
        item-key="id"
        class="elevation-0 table-full-screen text-gray-1100"
        show-select
        :height="alturaDaJanela - 150"
        :item-height="45"
      >
        <template #top>
          <div class="d-flex align-center pb-2 pt-3 px-2 w-full">
            <v-icon size="21">mdi-format-list-bulleted</v-icon>
            <span class="font-weight-medium font-19 ml-1 text-no-wrap">Lista de produtos</span>

            <ExcluirProdutoSilenciado
              v-show="produtos_selecionados.length > 0"
              class="ml-5"
              :produtos="produtos_selecionados"
              @update:delecao-produto="produtosExcluidos()"
            />

            <v-spacer />

            <div class="w-400">
              <v-text-field
                v-model="pesquisa"
                append-icon="mdi-magnify"
                label="Pesquisar"
                clearable
                hide-details
                dense
              ></v-text-field>
            </div>
          </div>
        </template>

        <template #item.filial="{item}">
          {{ item.filial > 0 ? `Filial ${item.filial}` : 'Geral'}}

          <template v-if="item.nome_fantasia_filial">
            - {{ item.nome_fantasia_filial }}
          </template>
        </template>

        <template #item.action="{ item }">
          <div class="d-flex align-center">
            <SilenciarProdutosDialog editando :produtos="[item]" @update:produtos-silenciados="buscarProdutosSilenciados()">
              <template #botao-ativador="{ callbackAbrirDialog }">
                <v-btn icon @click="callbackAbrirDialog()">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
            </SilenciarProdutosDialog>

            <ExcluirProdutoSilenciado
              :produtos="[item]" icon
              class="ml-n2"
              @update:delecao-produto="produtosExcluidos()"
            />
          </div>
        </template>
      </sys-data-table>
    </SysDialogFullscreen>
  </div>
</template>

<script>
import {buscarProdutosSilenciados, buscarQtdeProdutosSilenciados} from "@/api/compraPorProdutosGerais/NotificacaoBlackList";
import {logout} from "@/helpers";
import SysDialogFullscreen from "@/components/padraoDeLayout/SysDialogFullScreen";
import ExcluirProdutoSilenciado from "@/components/compra/ProdutosGerais/ProdutosSilenciados/ListaProdutos/ExcluirProdutoSilenciado";
import SilenciarProdutosDialog from "@/components/compra/ProdutosGerais/ProdutosSilenciados/SilenciarProdutosDialog";
import ResponsiveHeight from "@/helpers/ResponsiveHeight";

export default {
  name: "ListaProdutosSilenciados",
  mixins: [ResponsiveHeight],
  components: {
    SilenciarProdutosDialog,
    ExcluirProdutoSilenciado,
    SysDialogFullscreen
  },
  data: () => ({
    qtde_produtos_silenciados: null,
    dialog_ativo: false,
    pesquisa: '',
    produtos_selecionados: [],
    cabecalhos: [
      { text: "Grupo", value: "descricao" },
      { text: "Filial", value: "filial" },
      { text: "Fornecedor", value: "fornecedor" },
      { text: "ID Marca", value: "idmarca" },
      { text: "Marca", value: "descricao_marca" },
      { text: "ID Produto", value: "idproduto" },
      { text: "Produto", value: "descricao_produto" },
      { text: "ID Usuário", value: "id_usuario" },
      { text: "Nome Usuário", value: "nome_usuario" },
      { text: "Data Limite", value: "data_limite" },
      { text: "", value: "action", sortable: false },
    ],
    produtos: []
  }),
  computed: {
    FILTROS_STORE() {
      return this.$store.getters['CompraProdutosGerais/getFiltrosGerais'];
    }
  },
  watch: {
    FILTROS_STORE: {
      handler() {
        this.buscarQtdeProdutosSilenciados();
      },
      deep: true
    }
  },
  mounted() {
    this.buscarQtdeProdutosSilenciados();
    this.$store.dispatch("CompraProdutosGerais/callbackRecarregarQtdeProdutosSilenciados", this.buscarQtdeProdutosSilenciados);
  },
  methods: {
    buscarQtdeProdutosSilenciados() {
      this.qtde_produtos_silenciados = null;

      const parametros = {
        filtros: this.FILTROS_STORE
      };

      buscarQtdeProdutosSilenciados(parametros)
        .then(qtde => this.qtde_produtos_silenciados = qtde)
        .catch(logout)
    },
    buscarProdutosSilenciados() {
      if (this.qtde_produtos_silenciados === 0) return;

      const parametros = {
        filtros: this.FILTROS_STORE
      };

      this.$store.dispatch('loading/addRequisicao',
        buscarProdutosSilenciados(parametros)
          .then(produtos => this.produtos = produtos)
          .catch(logout)
      );
    },
    abrirDialog() {
      this.dialog_ativo = ! this.dialog_ativo;
      this.buscarProdutosSilenciados();
    },
    produtosExcluidos() {
      this.buscarProdutosSilenciados();
      this.buscarQtdeProdutosSilenciados();
      this.produtos_selecionados = [];
    }
  }
}
</script>

<style scoped>

</style>
